const LoanTrancheDelete = () => {
  return (
    <div className="loan-tranche-delete">
      <h1>Placeholder for Loan Tranche Delete</h1>
    </div>
  );
};

export default LoanTrancheDelete;
